export default "__VITE_ASSET__CPEulgQb__"